<div class="mt-16 pt-16 pr-24 pb-24 pl-16 bg-gray-pale br-4">
  <div>
    <span class="tt-uppercase">заполнение смен по шаблону</span>
  </div>
  <div class="grid grid--va-middle mt-16">
    <div class="grid__box grid__box--size-2">
      <div class="selected-users__title">
        <span class="title--s title--required">Выбранные сотрудники</span>
      </div>
    </div>
    <div class="grid__box" *ngIf="templateFilter.selectedUsers && templateFilter.selectedUsers.length">
      <div class="grid grid--gap-4">
        <div class="grid__box grid__box--size-min mb-4" *ngFor="let user of templateFilter.selectedUsers">
          <button type="button" class="button__reset-control">
            <span class="reset-control__name">
              {{ user && user.employee && user.employee.full_name }}
            </span>
            <button
              class="reset-control__icon"
              type="button"
              id="{{ 'appRemoveCollaborator' + user.u_id }}"
              (click)="onRemoveSelectedUser(user)"
              [disabled]="templateFilter.isActiveTemplateFilterPreviewMode"
            >
              <app-icon [glyph]="'hd-close-small'" [size]="'14'" [color]="'gray'"></app-icon>
            </button>
          </button>
        </div>
      </div>
    </div>
    <div class="grid__box" *ngIf="templateFilter.selectedUsers && !templateFilter.selectedUsers.length">
      <span class="text-italic color-gray">Кликом мыши по имени выберите одного или нескольких сотрудников из списка</span>
    </div>
  </div>
  <div class="mt-16 mb-16">
    <div class="delimiter delimiter--size-1 delimiter--gray-bright"></div>
  </div>
  <div class="grid grid--va-bottom">
    <div class="grid__box grid__box--size-2">
      <app-field>
        <label>
          <span class="title title--s title--required">Вид затрат времени</span>
        </label>
        <app-select
          [items]="templateFilterData.cellTypesList"
          (callback)="onChangeTemplateWorkType($event)"
          [textKey]="'ct_name'"
          [defaultText]="'Выберите значение'"
          [initBy]="templateFilter.workTypeSelected"
          [isDisabled]="templateFilter.isActiveTemplateFilterPreviewMode"
          [name]="'workTypes'"
        ></app-select>
      </app-field>
    </div>
    <div class="grid__box">
      <app-field>
        <label>
          <span class="title title--s title--required">График на период</span>
        </label>
        <content-block>
          <div class="grid grid--va-middle grid--gap-8">
            <div class="grid__box grid__box--size-min">с</div>
            <div class="grid__box">
              <app-date-time-picker
                [initDate]="templateFilter.startTemplatePeriod.initDate"
                [isShowTimepicker]="false"
                [datepickerName]="'startTemplatePeriodDate'"
                [options]="templateFilter.startTemplatePeriodOpts"
                [isDisabled]="templateFilter.isActiveTemplateFilterPreviewMode"
                (dateCallback)="onChangeStartTemplatePeriodDate($event)"
              ></app-date-time-picker>
            </div>
            <div class="grid__box grid__box--size-min">по</div>
            <div class="grid__box">
              <app-date-time-picker
                [initDate]="templateFilter.endTemplatePeriod.initDate"
                [isShowTimepicker]="false"
                [datepickerName]="'endTemplatePeriodDate'"
                [options]="templateFilter.endTemplatePeriodOpts"
                [isDisabled]="templateFilter.isActiveTemplateFilterPreviewMode"
                (dateCallback)="onChangeEndTemplatePeriodDate($event)"
              ></app-date-time-picker>
            </div>
          </div>
        </content-block>
      </app-field>
    </div>
    <div class="grid__box grid__box--size-2" *ngIf="templateFilter.workTypeSelected.ct_id === 1">
      <app-field>
        <label>
          <span class="title title--s title--required">Вид рабочего графика</span>
        </label>
        <app-select
          [items]="templateFilterData.scheduleTypesList"
          (callback)="onChangeTemplateCellType($event)"
          [textKey]="'st_name'"
          [defaultText]="'Выберите значение'"
          [initBy]="templateFilter.cellTypeSelected"
          [isDisabled]="templateFilter.isActiveTemplateFilterPreviewMode"
          [name]="'workTypesSchedule'"
        ></app-select>
      </app-field>
    </div>
    <div class="grid__box" *ngIf="templateFilter.workTypeSelected.ct_id === 1">
      <app-field>
        <label>
          <span class="title title--s title--required">Время смены</span>
        </label>
        <content-block>
          <div class="grid grid--va-middle grid--gap-8">
            <div class="grid__box grid__box--size-min">с</div>
            <div class="grid__box">
              <app-time-picker
                [(ngModel)]="templateFilter.startWorkTime"
                [disabled]="templateFilter.isActiveTemplateFilterPreviewMode"
                (ngModelChange)="onChangeStartTemplatePeriodTime($event)"
              ></app-time-picker>
            </div>
            <div class="grid__box grid__box--size-min">до</div>
            <div class="grid__box">
              <app-time-picker
                [(ngModel)]="templateFilter.endWorkTime"
                [disabled]="templateFilter.isActiveTemplateFilterPreviewMode"
                (ngModelChange)="onChangeEndTemplatePeriodTime($event)"
              ></app-time-picker>
            </div>
          </div>
        </content-block>
      </app-field>
    </div>
    <div class="grid__box grid__box--size-2" *ngIf="templateFilter.workTypeSelected.ct_id === 2">
      <app-field>
        <label>
          <span class="title title--s title--required">Временное место работы</span>
        </label>
        <app-combobox
          [items]="workPlacesList"
          (callback)="onChangeTemplateWorkPlace($event)"
          [textKey]="'sector_number_str'"
          [defaultText]="'Выберите значение'"
          [initBy]="templateFilter.workPlaceSelected"
          [isDisabled]="templateFilter.isActiveTemplateFilterPreviewMode"
          [name]="'workPlaces'"
        ></app-combobox>
      </app-field>
    </div>
    <div class="grid__box" *ngIf="templateFilter.workTypeSelected.ct_id !== 1">
      <app-field>
        <label>Комментарий</label>
        <input
          type="text"
          class="input-text"
          id="comment"
          [(ngModel)]="templateFilter.comment"
          placeholder="Введите комментарий"
          [disabled]="templateFilter.isActiveTemplateFilterPreviewMode"
        />
      </app-field>
    </div>
    <div class="grid__box grid__box--size-min grid__box--pull-right">
      <div class="grid grid--va-middle">
        <div class="grid__box grid__box--size-min">
          <button
            type="button"
            class="button"
            id="appChangeStatePreviewMode"
            (click)="onChangeTemplateFilterPreviewModeState()"
            [class.button--orange]="templateFilter.isActiveTemplateFilterPreviewMode"
            [disabled]="!templateFilter.selectedUsers.length || previewDisabled"
          >
            Предпросмотр
          </button>
        </div>
        <div class="grid__box grid__box--size-min">
          <button type="button" class="button" id="appSaveCellsSchedule" (click)="onSaveCellsSelectedUsers()" [disabled]="!templateFilter.isActiveTemplateFilterPreviewMode">
            Сохранить
          </button>
        </div>
        <div class="grid__box grid__box--size-min">
          <button
            type="button"
            id="appResetTemplateFilter"
            class="ctrl link link--dotted-gray-dark"
            (click)="onResetTemplateFilter.emit(true)"
            [disabled]="templateFilter.isActiveTemplateFilterPreviewMode"
            [class.link--disabled]="templateFilter.isActiveTemplateFilterPreviewMode"
          >
            Очистить
          </button>
        </div>
      </div>
    </div>
  </div>
  <div class="mt-16" *ngIf="templateError">
    <app-message [type]="'error'">
      <div message-content>{{ templateError }}</div>
    </app-message>
  </div>
</div>
